var _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWavexl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1439,
    height: 191,
    viewBox: "0 0 1439 191",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 59.9521L40 68.7553C80 77.6585 160 95.265 240 97.7659C320 100.267 400 87.6622 480 72.1566C560 56.6509 640 38.2441 720 22.4384C800 6.63258 880 -6.77233 960 3.73151C1040 14.2353 1120 48.648 1200 67.1547C1280 85.6615 1360 88.2624 1400 89.663L1440 90.9634V191H1400C1360 191 1280 191 1200 191C1120 191 1040 191 960 191C880 191 800 191 720 191C640 191 560 191 480 191C400 191 320 191 240 191C160 191 80 191 40 191H0V59.9521Z",
    fill: "url(#paint0_linear_14_26)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_14_26",
    x1: 720,
    y1: 0,
    x2: 720,
    y2: 191,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCD85"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCD85",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWavexl);
export default __webpack_public_path__ + "static/media/wavexl.5c7b4e79fc464e8fd74727d75736847c.svg";
export { ForwardRef as ReactComponent };